export const GET_RECOMMENDATIONS = 'GET_RECOMMENDATIONS';

export const GET_DEFAULT_RECOMMENDATIONS = 'GET_DEFAULT_RECOMMENDATIONS';
export const GET_DEFAULT_RECOMMENDATIONS_SUCCESS =
  'GET_DEFAULT_RECOMMENDATIONS_SUCCESS';

export const GET_FILTERED_RECOMMENDATIONS = 'GET_FILTERED_RECOMMENDATIONS';
export const GET_FILTERED_RECOMMENDATIONS_SUCCESS =
  'GET_FILTERED_RECOMMENDATIONS_SUCCESS';

export const GET_MORE_RECOMMENDATIONS = 'GET_MORE_RECOMMENDATIONS';
export const GET_MORE_RECOMMENDATIONS_SUCCESS =
  'GET_MORE_RECOMMENDATIONS_SUCCESS';

export const UPDATE_RECOMMENDATION_STATUS = 'UPDATE_RECOMMENDATION_STATUS';
export const UPDATE_RECOMMENDATION_STATUS_SUCCESS =
  'UPDATE_RECOMMENDATION_STATUS_SUCCESS';

export const HIDE_RECOMMENDATION = 'HIDE_RECOMMENDATION';
export const SET_HIDING_RECOMMENDATION = 'SET_HIDING_RECOMMENDATION';
export const REMOVE_RECOMMENDATION_FROM_LIST =
  'REMOVE_RECOMMENDATION_FROM_LIST';



// WEBPACK FOOTER //
// ./src/actionTypes/recommendationActionTypes.js